import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import HeaderComponent from "./Header/HeaderComponent";
import SidebarComponent from "./Sidebar/SidebarComponent";
import FooterComponent from "./Footer/FooterComponent";
import LoginComponent from "./Login/LoginComponent";
import Page404 from "./404Page";
import PageNotFound from "./PageNotFound";
import Created from "./Password/created/Created";
import Shared from "./Password/shared/Shared";
import Folder from "./folder/Folder";
import Environment from "./folder/Environment";
import Cookies from "js-cookie";
import EnvironmentDetails from "./folder/EnvironmentDetails";
import Users from "./Users/Users";
import AuditLogs from "./AuditLogs/AuditLogs";
const isLoggedIn = () => {
  const token = Cookies.get("access_token");
  // console.log(token);
  const loggedInUser = JSON.parse(
    localStorage.getItem("loggedInUser")
  );
  return loggedInUser !== null;
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn() ? (
        <>
          <div className="mainWrapper">
            <SidebarComponent />
            <div className="container-body">
              <HeaderComponent title={rest?.title} />
              <Component {...props} />
            </div>
          </div>
          <FooterComponent />
        </>
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

const PublicRoute = ({
  component: Component,
  restricted,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn() && restricted ? (
        <Redirect to="/created" />
      ) : (
        <Component {...props} />
      )
    }
  />
);

const Routes = (props) => {
  return (
    <Switch>
      <Route
        exact
        path="/"
        render={(props) => <Redirect to="/created" />}
      />

      <PrivateRoute
        path="/created"
        component={Created}
        title={"Passwords"}
      />
      <PrivateRoute
        path="/shared"
        component={Shared}
        title={"Passwords"}
      />
      <PrivateRoute
        path="/folder_project"
        component={Folder}
        title={"Folders"}
      />
      <PrivateRoute
        path="/env_subfolder/:folderId"
        component={Environment}
        title={"Folders"}
      />
      <PrivateRoute
        path="/env_passwords/:envId"
        component={EnvironmentDetails}
        title={"Passwords"}
      />
      <PrivateRoute path="/users" component={Users} title={"Users"} />
      <PrivateRoute
        path="/audit"
        component={AuditLogs}
        tile={"Audit Logs"}
      />

      <PublicRoute
        restricted={true}
        exact
        path="/login"
        component={LoginComponent}
      />

      <Route path="/pageNotFound" component={PageNotFound} />
      <Route component={Page404} />
    </Switch>
  );
};

export default Routes;
